/**
 * Routes list
 * Analytics labels API
 */
let _prefix = '/analytics/v1'

export default {
  //Признаки и их папки
  propertyFolder: _prefix + '/properties-folder',
  propertyFolders: _prefix + '/properties-folders',
  restorePropertyFolder: _prefix + '/restore-properties-folder',
  property: _prefix + '/property',
  properties: _prefix + '/properties',
  restoreProperty: _prefix + '/restore-property',
  propertiesData: _prefix + '/properties-data',
  
  //Объекты учета и их папки
  objectsFolder: _prefix + '/objects-folder',
  restoreObjectsFolder: _prefix + '/restore-objects-folder',
  objectsFolders: _prefix + '/objects-folders',
  object: _prefix + '/object',
  objects: _prefix + '/objects',
  restoreObject: _prefix + '/restore-object',
  objectsData: _prefix + '/objects-data',
  
  //Формы ввода и их папки
  setting: _prefix + '/setting',
  settings: _prefix + '/settings',
  settingFolder: _prefix + '/setting-folder',
  settingFolders: _prefix + '/settings-folders',
  
  //Доступы к объектам
  watchers: _prefix + '/watchers',
  addWatcher: _prefix + '/add-to-watcher',
  assignedObjects: _prefix + '/assigned-object',
  
  //Интерфейс администратора
  countMatch: _prefix + '/count',
  showMatch: _prefix + '/rows',
  objectValues: _prefix + '/rows-values',
  mergeObjects: _prefix + '/join',
  getDataTable: _prefix + '/properties-table'
}



// WEBPACK FOOTER //
// ./src/apps/analytics/api/constructor/routes.js